import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const ProtectionProgramService = {
    list: async (filter) => axios.post(API_KEEPER + "/sos/protection-program/list", filter).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/sos/protection-program/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + "/sos/protection-program", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (data, id) => axios.put(API_KEEPER + "/sos/protection-program/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/sos/protection-program/" + id).catch((err) => { throw err }),

    options: async () => axios.get(API_KEEPER + `/sos/protection-program/options`).then(({data}) => data).catch((err) => { throw err }),
};

export default ProtectionProgramService;